document.addEventListener("DOMContentLoaded", function () {
  const galleryThumbs = new Swiper(".gallery-thumbs", {
    centeredSlides: false,
    centeredSlidesBounds: false,
    direction: "horizontal",
    spaceBetween: 10,
    slidesPerView: 3,
    freeMode: false,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    watchOverflow: true,
    navigation: {
      nextEl: ".gallery__thumbs--button-next",
      prevEl: ".gallery__thumbs--button-prev",
    },
    breakpoints: {
      989: {
        direction: "vertical",
        slidesPerView: 4,
      },
    },
  });

  const galleryTop = new Swiper(".gallery-top", {
    direction: "horizontal",
    spaceBetween: 10,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    a11y: {
      prevSlideMessage: "Previous slide",
      nextSlideMessage: "Next slide",
    },
    keyboard: {
      enabled: true,
    },
    thumbs: {
      swiper: galleryThumbs,
    },
  });
});


class MediaGallery {
    constructor(selector) {
        this.selector = selector;
        this.init();
    }
    // Initialize the gallery
    init() {
        this.setupExpandButton();
    }
    // Handle the expand button click and modal behavior
    setupExpandButton() {
        console.log("Selector:", this.selector);
        const mediaGallery = document.querySelector(this.selector);

        if (mediaGallery) {
            const expandButton = mediaGallery.querySelector(".media-gallery__expand-button");

            if (expandButton) {
                expandButton.addEventListener("click", (event) => {
                    event.preventDefault();

                    const currentSlide = mediaGallery.querySelector(".gallery-top .swiper-slide-active");

                    if (currentSlide) {
                        const currentDataIndex = currentSlide.dataset.index;
                        const popupModalMedia = document.querySelector("#PopupModal-media");

                        if (popupModalMedia) {
                            popupModalMedia.setAttribute("open", "");

                            const mediaGalleryModalContainer = popupModalMedia.querySelector(".media-gallery__modal-container");

                            if (mediaGalleryModalContainer) {
                                mediaGalleryModalContainer.classList.add("active");

                                // Scroll to the specific index in the modal
                                const targetMediaItem = popupModalMedia.querySelector(
                                    `[data-media-modal-item="${currentDataIndex}"]`
                                );

                                if (targetMediaItem) {
                                    targetMediaItem.scrollIntoView({
                                        behavior: "smooth",
                                        block: "start",
                                        inline: "nearest"

                                    });

    
                                    // console.log("Scrolled to media item:", targetMediaItem);
                                } else {
                                    console.warn(`No media item found for index: ${currentDataIndex}`);
                                }
                            }
                        }
                    }
                });
            }
        }
    }
}

// Usage
document.addEventListener("DOMContentLoaded", () => {
    const mediaGallery = new MediaGallery(".MediaGallery-template");
});



// class MediaGallery {
//     constructor(selector) {
//         this.triggerData(selector);
//     }
//     // Add the triggerData function
//     triggerData(selector) {
//         console.log("selector", selector)
//         let mediaGallery = document.querySelector(selector);
//         if(mediaGallery){
//           let expandButton = mediaGallery.querySelector(".media-gallery__expand-button");
//           console.log("expandButton", expandButton)
//           if(expandButton){
//             expandButton.addEventListener("click", function (event) {
//               event.preventDefault();
//               let currentSlide = mediaGallery.querySelector(".gallery-top .swiper-slide-active");
//               if(currentSlide){
//                 let currentDataIndex = currentSlide.dataset.index;
//                 console.log("currentDataIndex", currentDataIndex)
//                 let popupModalMedia = document.querySelector("#PopupModal-media");
//                 if(popupModalMedia){
//                   popupModalMedia.setAttribute("open", "")
//                   let mediaGalleryModalContainer = popupModalMedia.querySelector(".media-gallery__modal-container");
//                   if(mediaGalleryModalContainer){
//                     mediaGalleryModalContainer.classList.add("active");
//                   }
//                 }
//               }
//             })
//           }
//         }

//     }
// }

// // Usage
// document.addEventListener('DOMContentLoaded', () => {
//     const mediaGallery = new MediaGallery('.MediaGallery-template'); // Update ID to match your HTML

//     // Example: Trigger a custom event
//     mediaGallery.triggerData('mediaGalleryLoaded', { message: 'Media gallery is ready' });
// });
